import { Api } from "@/services/Api";
import store from "../store";

export default {
  bookings() {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().get("host/bookings", {
      headers
    });
  },
  bookingView(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/booking/view", data, {
      headers
    });
  },
  addReview(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/add/review", data, {
      headers
    });
  },
  unPublishReview(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/unpublish/review", data, {
      headers
    });
  },
  createContract(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/create-contract", data, {
      headers
    });
  },
  editContract(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/edit-contract", data, {
      headers
    });
  },
  updateContract(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/update-contract", data, {
      headers
    });
  },
  searchContractTerms(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/search-contract-terms", data, {
      headers
    });
  },
  addContractTerms(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/add-contract-terms", data, {
      headers
    });
  },
  updateContractTerms(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/update-contract-terms", data, {
      headers
    });
  },
  deleteContractTerms(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/delete-contract-terms", data, {
      headers
    });
  },
  deleteContract(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/delete-contract", data, {
      headers
    });
  },
  getTerms(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/get-contract-terms", data, {
      headers
    });
  },
  setupPayout(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("payouts/setup", data, {
      headers
    });
  },
  editPayout() {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().get("payouts/edit-payout", {
      headers
    });
  },
  makeDefaultPayout(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api(data).post("payouts/default", data, {
      headers
    });
  },
  deleteAccount(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api(data).post("payouts/delete", data, {
      headers
    });
  },
  getConnectAccount() {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().get("payouts/account", {
      headers
    });
  },
  updateTripStatus(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api(data).post("host/update_trip_status", data, {
      headers
    });
  },
  monthlyReport(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/report", data, {
      headers
    });
  },
  exportReport(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/report/export", data, {
      headers,
      responseType: "arraybuffer"
    });
  },
  viewCancelBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/view-cancel", data, {
      headers
    });
  },
  cancelBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("host/cancel-booking", data, {
      headers
    });
  }
};
